import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { AppDB } from './database';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class DataStoreService {

  isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private db: AppDB) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  async get(key: string): Promise<any> {
    if (this.isBrowser) {
      try {
        const item: any = await this.db.appStorage.getItem(key);
        return item;
      } catch (err) {
        console.log(err);
      }        
    }
  }

  async save(key: string, value: any): Promise<any> {
    if (this.isBrowser) {
      await this.db.appStorage.setItem(key, value);
    }
  }

  async delete(key: string): Promise<any> {
    if (this.isBrowser) {
      await this.db.appStorage.removeItem(key);
    }
  }

  async clear(): Promise<any> {
    if (this.isBrowser) {
      await this.db.appStorage.clear();
    }
  }

}
